import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import * as i4 from '@upr-web-primer/gds-input-helper';
import { gdsPasswordValidator, gdsEmailValidator, gdsNameValidator, GdsInputHelperDirective, GdsInputHelperModule } from '@upr-web-primer/gds-input-helper';
import { get as get$1, isArray } from 'lodash-es';
import { Subject } from 'rxjs';
import * as i2 from '@angular/forms';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i1 from '@angular/router';
import get from 'lodash-es/get';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';

class GdsDynamicFormService {
    constructor(route) {
        this.route = route;
        this.route.data.subscribe((data) => {
            this.pageLabels = get(data, 'pageLabels');
        });
    }
    customFormGroup(inputData) {
        const group = {};
        inputData.forEach(inputItem => {
            switch (inputItem.type) {
                case 'text':
                    group[inputItem.key] = new FormControl(inputItem.value || '', gdsNameValidator(this.pageLabels?.ER26, this.pageLabels?.ER26, this.pageLabels?.ER1));
                    break;
                case 'email':
                    group[inputItem.key] = new FormControl(inputItem.value || '', gdsEmailValidator(this.pageLabels?.ER26, this.pageLabels?.ER6));
                    break;
                case 'password':
                    group[inputItem.key] = new FormControl(inputItem.value || '', gdsPasswordValidator(this.pageLabels?.ER26, this.pageLabels?.ER9));
                    break;
                default:
                    group[inputItem.key] = new FormControl(inputItem.value || '');
                    break;
            }
        });
        return new FormGroup(group);
    }
}
GdsDynamicFormService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsDynamicFormService, deps: [{ token: i1.ActivatedRoute }], target: i0.ɵɵFactoryTarget.Injectable });
GdsDynamicFormService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsDynamicFormService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsDynamicFormService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.ActivatedRoute }]; } });

class GdsInputBase {
    constructor(options = {}) {
        this.value = options.value;
        this.primaryLabel = options.primaryLabel || '';
        this.secondaryText = options.secondaryText || '';
        this.type = options.type || '';
        this.key =
            options.key || this.type === 'password'
                ? this.type
                : 'formInput' + this.primaryLabel?.split(' ')[0];
        this.name =
            options.name || this.type === 'password'
                ? this.type
                : 'formInput' + this.primaryLabel?.split(' ')[0];
        this.altText = options.altText || '';
        this.ariaText = options.ariaText || '';
        this.required = !!options.required;
    }
}

class GdsDynamicFormComponent extends GdsInputHelperDirective {
    constructor(elementRef, gdfs) {
        super(elementRef);
        this.gdfs = gdfs;
        this.inputPayLoad = new Subject();
    }
    ngOnInit() {
        this.pageLabels = this.gdfs.pageLabels;
        const inputs = [].concat(get$1(this.data, 'gdsInputs'));
        this.contrast = get$1(this.data, 'contrast');
        this.theme = get$1(this.data, 'theme');
        if (isArray(inputs) && inputs.length) {
            this.inputData = inputs.map((inputItem) => {
                return new GdsInputBase(inputItem);
            });
            this.inputForm = this.gdfs.customFormGroup(this.inputData);
        }
    }
    get formControls() {
        return this.inputForm?.controls;
    }
    get isInvalid() {
        return this.inputForm?.invalid ? 'true' : 'false';
    }
    onSubmit() {
        if (this.inputForm.valid) {
            this.inputPayLoad.next(this.inputForm.value);
            this.inputForm.reset();
        }
    }
}
GdsDynamicFormComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsDynamicFormComponent, deps: [{ token: i0.ElementRef }, { token: GdsDynamicFormService }], target: i0.ɵɵFactoryTarget.Component });
GdsDynamicFormComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: GdsDynamicFormComponent, selector: "upr-gds-dynamic-form", inputs: { data: "data", contrast: "contrast", theme: "theme" }, usesInheritance: true, ngImport: i0, template: "<form [formGroup]=\"inputForm\">\r\n\t<div *ngFor=\"let input of inputData\">\r\n\t\t<gds-input\r\n\t\t\t[formControlName]=\"input?.key\"\r\n\t\t\t[data]=\"input\"\r\n\t\t\t[errors]=\"formControls[input.key]?.errors?.message\"\r\n\t\t></gds-input>\r\n\t\t<gds-spacer classes=\"spacer-50\"></gds-spacer>\r\n\t</div>\r\n\t<gds-button\r\n\t\t[data]=\"{\r\n\t\t\ttype: 'primary',\r\n\t\t\tlabel: pageLabels?.lblManageAccountRegister || 'Create Account',\r\n\t\t\tdisabled: isInvalid\r\n\t\t}\"\r\n\t\t(buttonClicked)=\"onSubmit()\"\r\n\t></gds-button>\r\n</form>\r\n", directives: [{ type: i2.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i2.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i2.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i3.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i4.GdsInputHelperDirective, selector: "gds-input" }, { type: i2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i2.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsDynamicFormComponent, decorators: [{
            type: Component,
            args: [{ selector: 'upr-gds-dynamic-form', template: "<form [formGroup]=\"inputForm\">\r\n\t<div *ngFor=\"let input of inputData\">\r\n\t\t<gds-input\r\n\t\t\t[formControlName]=\"input?.key\"\r\n\t\t\t[data]=\"input\"\r\n\t\t\t[errors]=\"formControls[input.key]?.errors?.message\"\r\n\t\t></gds-input>\r\n\t\t<gds-spacer classes=\"spacer-50\"></gds-spacer>\r\n\t</div>\r\n\t<gds-button\r\n\t\t[data]=\"{\r\n\t\t\ttype: 'primary',\r\n\t\t\tlabel: pageLabels?.lblManageAccountRegister || 'Create Account',\r\n\t\t\tdisabled: isInvalid\r\n\t\t}\"\r\n\t\t(buttonClicked)=\"onSubmit()\"\r\n\t></gds-button>\r\n</form>\r\n" }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: GdsDynamicFormService }]; }, propDecorators: { data: [{
                type: Input
            }], contrast: [{
                type: Input
            }], theme: [{
                type: Input
            }] } });

class GdsDynamicFormModule {
}
GdsDynamicFormModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsDynamicFormModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
GdsDynamicFormModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsDynamicFormModule, declarations: [GdsDynamicFormComponent], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        GdsInputHelperModule], exports: [GdsDynamicFormComponent] });
GdsDynamicFormModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsDynamicFormModule, imports: [[
            CommonModule,
            FormsModule,
            ReactiveFormsModule,
            GdsInputHelperModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsDynamicFormModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [GdsDynamicFormComponent],
                    imports: [
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        GdsInputHelperModule
                    ],
                    exports: [GdsDynamicFormComponent],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA]
                }]
        }] });

export { GdsDynamicFormComponent, GdsDynamicFormModule, GdsDynamicFormService };
